import type { ReactNode } from 'react';
import type {
  AutocompleteGroupSorterFunc,
  AutocompleteResultsProps,
  UseAutocompleteOutput,
} from '../Autocomplete/types';
import type { UseDropdownPopperOutput, UseDropdownPopperProps } from '../Dropdown';
import type { DropdownProps } from '../Dropdown/Dropdown';

export type SuffixCallbackParams = {
  selectedGroup?: string;
  closeMenu: () => void;
};

export type AutocompleteDropdownProps<T> = UseDropdownPopperOutput &
  Omit<DropdownProps, 'children'> &
  AutocompleteResultsProps<T> &
  Pick<UseAutocompleteOutput<T>, 'tabs'> & {
    childrenAboveResults?: ReactNode;
    /** Whether or not to show the group tabs at the top of the dropdown */
    showGroupTabs?: boolean;
    /** When true, the group tab bar will not collapse tabs into a "More" overflow popover
     * TODO: This is a workaround because the More button shows up earlier than it should size-wise
     * - See follow-up PR https://talostrading.atlassian.net/browse/UI-7358 for reproducible example
     */
    suppressGroupTabsOverflow?: boolean;
    groupsPrefix?: ReactNode;
    groupSorter?: AutocompleteGroupSorterFunc;
    /** Provide your own testID to be used to wrap the dropdown contents */
    testID?: string;
    /**
     * Optional callback function to render suffix dynamically based on callback props, like `selectedGroup` and `closeMenu`.
     */
    suffixCb?: (params: SuffixCallbackParams) => ReactNode;
  };
// Expose a subset of the props for now
// also cast the <T> to any since we're not using it

export type ExposedAutocompleteDropdownProps<T = any> = Pick<
  AutocompleteDropdownProps<T>,
  | 'portalize'
  | 'maxHeight'
  | 'groupMaxHeight'
  | 'RenderGroupHeader'
  | 'suffix'
  | 'suffixCb'
  | 'showGroupTabs'
  | 'suppressGroupTabsOverflow'
> &
  Pick<UseDropdownPopperProps, 'dropdownPlacement' | 'dropdownWidth'>;

export const ALL_TAB = {
  group: 'All',
};
